<template>
    <small class="text-info">Загрузка скана не является обязательной, но мы должны иметь возможность проверить введённые паспортные данные. Вы можете предъявить паспорт лично, приехав к нам в офис.</small>
</template>
<script>
export default {
}
</script>
